
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import { addAgentLimit } from "./../../../actions/add-agent-limit-action";
import { useData } from "../../../contexts/dataContext";
import  ConfigurationService  from './../../../services//configuration-service'


const initialErrorsState = {
  limit_group_name: "",
  min_amount_cashin_limit: "",
  max_amount_cashin_limit: "",
  daily_cash_in_limit: "",
  weekly_cash_in_limit: "",
  monthly_cash_in_limit: "",
  daily_cash_in_limit_count: "",
  weekly_cash_in_limit_count: "",
  monthly_cash_in_limit_count: "",
  min_amount_cashout_limit: "",
  max_amount_cashout_limit: "",
  daily_cash_out_limit: "",
  weekly_cash_out_limit: "",
  monthly_cash_out_limit: "",
  daily_cash_out_limit_count: "",
  weekly_cash_out_limit_count: "",
  monthly_cash_out_limit_count: "",
};

const AddAgentLimitView = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("list_per_details5");
  const [isError, setIsError] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = useData();

  const [formData, setFormData] = useState({
    limit_group_name: data?.limit_group_name ?? "",
    min_amount_cashin_limit: data?.min_amount_cashin_limit ?? "",
    max_amount_cashin_limit: data?.max_amount_cashin_limit ?? "",
    daily_cash_in_limit: data?.daily_cash_in_limit ?? "",
    weekly_cash_in_limit: data?.weekly_cash_in_limit ?? "",
    monthly_cash_in_limit: data?.monthly_cash_in_limit ?? "",
    daily_cash_in_limit_count: data?.daily_cash_in_limit_count ?? "",
    weekly_cash_in_limit_count: data?.weekly_cash_in_limit_count ?? "",
    monthly_cash_in_limit_count: data?.monthly_cash_in_limit_count ?? "",
  });

  const [payoutFormData, setPayoutFormData] = useState({
    min_amount_cashout_limit: data?.min_amount_cashout_limit ?? "",
    max_amount_cashout_limit: data?.max_amount_cashout_limit ?? "",
    daily_cash_out_limit: data?.daily_cash_out_limit ?? "",
    weekly_cash_out_limit: data?.weekly_cash_out_limit ?? "",
    monthly_cash_out_limit: data?.monthly_cash_out_limit ?? "",
    daily_cash_out_limit_count: data?.daily_cash_out_limit_count ?? "",
    weekly_cash_out_limit_count: data?.weekly_cash_out_limit_count ?? "",
    monthly_cash_out_limit_count: data?.monthly_cash_out_limit_count ?? "",
  });

  const [payInformData] = useState({
    default_limit_group: data?.default_limit_group ?? true,
    status: data?.status ?? "Active",
    status_id: data?.status_id ?? "A",
    created_on: data?.created_on ?? null,
    created_by: data?.created_by ?? 1,
    updated_on: data?.updated_on ?? null,
    updated_by: data?.updated_by ?? null,
  });

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const handlePayoutChange = (e) => {
    const { name, value } = e.target;
    setPayoutFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const [errors, setErrors] = useState({ ...initialErrorsState });

  const validateField = (fieldName, value) => {
    let errorMessage = "";

    if (fieldName === "limit_group_name" && !value.trim()) {
      errorMessage = "Limit Group Name is required";
    } else if (fieldName === "min_amount_cashin_limit" && value <= 0) {
      errorMessage = "Minimum Amount should be greater than 0";
    } else if (
      fieldName === "max_amount_cashin_limit" &&
      value <= formData["min_amount_cashin_limit"]
    ) {
      errorMessage = "Maximum Amount should be greater than Minimum Amount";
    } else if (fieldName === "daily_cash_in_limit" && value <= 0) {
      errorMessage = "Daily Limit should be greater than 0";
    } else if (
      fieldName === "weekly_cash_in_limit" &&
      value <= formData["daily_cash_in_limit"]
    ) {
      errorMessage = "Weekly Limit should be greater than Daily Limit";
    } else if (
      fieldName === "monthly_cash_in_limit" &&
      value <= formData["weekly_cash_in_limit"]
    ) {
      errorMessage = "Monthly Limit should be greater than Weekly Limit";
    } else if (fieldName === "daily_cash_in_limit_count" && value <= 0) {
      errorMessage = "Daily Limit Count should be greater than 0";
    } else if (
      fieldName === "weekly_cash_in_limit_count" &&
      value <= formData["daily_cash_in_limit_count"]
    ) {
      errorMessage =
        "Weekly Limit Count should be greater than Daily Limit Count";
    } else if (
      fieldName === "monthly_cash_in_limit_count" &&
      value <= formData["weekly_cash_in_limit_count"]
    ) {
      errorMessage =
        "Monthly Limit Count should be greater than Weekly Limit Count";
    } else if (fieldName === "min_amount_cashout_limit" && value <= 0) {
      errorMessage = "Minimum Amount should be greater than 0";
    } else if (
      fieldName === "max_amount_cashout_limit" &&
      value <= payoutFormData["min_amount_cashout_limit"]
    ) {
      errorMessage = "Maximum Amount should be greater than Minimum Amount";
    } else if (fieldName === "daily_cash_out_limit" && value <= 0) {
      errorMessage = "Daily Limit should be greater than 0";
    } else if (
      fieldName === "weekly_cash_out_limit" &&
      value <= payoutFormData["daily_cash_out_limit"]
    ) {
      errorMessage = "Weekly Limit should be greater than Daily Limit";
    } else if (
      fieldName === "monthly_cash_out_limit" &&
      value <= payoutFormData["weekly_cash_out_limit"]
    ) {
      errorMessage = "Monthly Limit should be greater than Weekly Limit";
    } else if (fieldName === "daily_cash_out_limit_count" && value <= 0) {
      errorMessage = "Daily Limit Count should be greater than 0";
    } else if (
      fieldName === "weekly_cash_out_limit_count" &&
      value <= payoutFormData["daily_cash_out_limit_count"]
    ) {
      errorMessage =
        "Weekly Limit Count should be greater than Daily Limit Count";
    } else if (
      fieldName === "monthly_cash_out_limit_count" &&
      value <= payoutFormData["weekly_cash_out_limit_count"]
    ) {
      errorMessage =
        "Monthly Limit Count should be greater than Weekly Limit Count";
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const handleNextSubmit = () => {
    // // Validate form fields
    Object.keys(formData).forEach((fieldName) =>
      validateField(fieldName, formData[fieldName])
    );
    const hasErrors = Object.values(formData).some((value) => value === "");

    if (!hasErrors) {
      handleTabClick("list_address_details5");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // // Validate form fields
    Object.keys(payoutFormData).forEach((fieldName) =>
      validateField(fieldName, payoutFormData[fieldName])
    );

    const hasErrors = Object.values(payoutFormData).some(
      (value) => value === ""
    );

    const combinedFormData = {
      ...formData,
      ...payoutFormData,
      ...payInformData,
    };

    if (!hasErrors) {
      setLoading(true);
      if(data){
        ConfigurationService.updateAgentLimit(data.limit_group_id, combinedFormData)
        .then((response) => {
          setLoading(false);
          toast.success(MESSAGES.AGENT_LIMIT_UPDATED);
          navigate("/limits");
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          setLoading(false);
          // setErrorMsg(errorMessage.error.message);
          toast.error(errorMessage.error.message);
        });

      }else{
        dispatch(addAgentLimit(combinedFormData))
        .then((response) => {
          setLoading(false);
          toast.success(MESSAGES.AGENT_LIMIT_CREATED);
          navigate("/limits");
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          setLoading(false);
          // setErrorMsg(errorMessage.error.message);
          toast.error(errorMessage.error.message);
        });
      }
     
    }
  };

  return (
    <div>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <h4 style={{ marginTop: "0", fontWeight: "700", fontSize: "16px" }}>
          {data ? 'Edit Agent Limits': 'Add Agent Limits'}
        </h4>
        <div
          className="container-fluid ghty"
          style={{ backgroundColor: "white", height: "auto" }}
        >
          <form
            method="post"
            id="register_form"
            className="merchant_form"
            onSubmit={handleSubmit}
          >
            <ul className="nav nav-tabs">
              <li className="nav-item tbbtrn">
                <a
                  className={`nav-link ${
                    activeTab === "list_per_details5"
                      ? "active_tab1"
                      : "inactive_tab1"
                  }`}
                  id="list_per_details5"
                >
                  Payin
                </a>
              </li>
              <li className="nav-item tbbtrn">
                <a
                  className={`nav-link ${
                    activeTab === "list_address_details5"
                      ? "active_tab1"
                      : "inactive_tab1"
                  }`}
                  id="list_address_details5"
                >
                  Payout
                </a>
              </li>
            </ul>
            <div className="tab-content" style={{ marginTop: "16px" }}>
              <div
                className={`tab-pane ${
                  activeTab === "list_per_details5" ? "active" : "fade"
                }`}
                id="per_details"
              >
                <div className="panel panel-default">
                  <div className="panel-body" style={{ padding: "0px" }}>
                    <div className="col-md-12" style={{ padding: "" }}>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="f_name">LIMIT GROUP NAME</label>
                          <input
                            type="text"
                            className={`form-control ${errors.limit_group_name ? 'is-invalid' : ''}`}
                            id="f_name"
                            placeholder="Enter Limit Group Name"
                            name="limit_group_name"
                            value={formData.limit_group_name}
                            onChange={handleChange}
                          />
                          <span id="error_fname" className="text-danger">
                            {errors.limit_group_name}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MINIMUM AMOUNT</label>
                          <input
                          
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.min_amount_cashin_limit ? 'is-invalid' : ''}`}
                            id="min_amount_cashin_limit"
                            placeholder="Enter Minimum Amount"
                            name="min_amount_cashin_limit"
                            value={formData.min_amount_cashin_limit}
                            onChange={handleChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.min_amount_cashin_limit}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MAXIMUM AMOUNT</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.max_amount_cashin_limit ? 'is-invalid' : ''}`}
                            id="max_amount_cashin_limit"
                            placeholder="Enter Maximum Amount"
                            name="max_amount_cashin_limit"
                            value={formData.max_amount_cashin_limit}
                            onChange={handleChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.max_amount_cashin_limit}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12" style={{padding: 0}}>
        <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
          <div className="form-group frm" style={{textAlign: 'left'}}>
            <label htmlFor="f_name">SET DEFAULT</label>
            <select name="set_default" className="drp" id="set_default">
              <option value="Yes">Yes</option>
              <option value="No" selected>No</option>
            </select>
          </div>
        </div>
      </div>
                  </div>
                </div>
                <div className="panel panel-default">
                  <div className="panel-body" style={{ padding: "0px" }}>
                    <div className="col-md-12" style={{ padding: 0 }}>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        Transaction Limits
                      </h6>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="f_name">DAILY</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.daily_cash_in_limit ? 'is-invalid' : ''}`}
                            id="daily_cash_in_limit"
                            placeholder="Enter Daily Limits"
                            name="daily_cash_in_limit"
                            value={formData.daily_cash_in_limit}
                            onChange={handleChange}
                          />
                          <span id="error_fname" className="text-danger">
                            {errors.daily_cash_in_limit}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">WEEKLY</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.daily_caweekly_cash_in_limitsh_in_limit ? 'is-invalid' : ''}`}

                            id="weekly_cash_in_limit"
                            placeholder="Enter Weekly Limits"
                            name="weekly_cash_in_limit"
                            value={formData.weekly_cash_in_limit}
                            onChange={handleChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.weekly_cash_in_limit}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MONTHLY</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.monthly_cash_in_limit ? 'is-invalid' : ''}`}

                            id="monthly_cash_in_limit"
                            placeholder="Enter Monthly Limits"
                            name="monthly_cash_in_limit"
                            value={formData.monthly_cash_in_limit}
                            onChange={handleChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.monthly_cash_in_limit}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="panel panel-default">
                  <div className="panel-body" style={{ padding: "0px" }}>
                    <div className="col-md-12" style={{ padding: 0 }}>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        Transaction Count
                      </h6>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">DAILY</label>
                          <input
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,0);"
                            className={`form-control ${errors.daily_cash_in_limit_count ? 'is-invalid' : ''}`}

                            id="daily_cash_in_limit_count"
                            placeholder="Enter Daily Count"
                            name="daily_cash_in_limit_count"
                            value={formData.daily_cash_in_limit_count}
                            onChange={handleChange}
                          />
                          <span id="error_fname" className="text-danger">
                            {errors.daily_cash_in_limit_count}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">WEEKLY</label>
                          <input
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,0);"
                            className={`form-control ${errors.weekly_cash_in_limit_count ? 'is-invalid' : ''}`}

                            id="weekly_cash_in_limit_count"
                            placeholder="Enter Weekly Count"
                            name="weekly_cash_in_limit_count"
                            value={formData.weekly_cash_in_limit_count}
                            onChange={handleChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.weekly_cash_in_limit_count}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MONTHLY</label>
                          <input
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,0);"
                            className={`form-control ${errors.monthly_cash_in_limit_count ? 'is-invalid' : ''}`}
                            id="monthly_cash_in_limit_count"
                            placeholder="Enter Monthly Count"
                            name="monthly_cash_in_limit_count"
                            value={formData.monthly_cash_in_limit_count}
                            onChange={handleChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.monthly_cash_in_limit_count}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <br />
                <div align="left">
                  <button
                    type="button"
                    name="btn_asubmit"
                    id="btn_limits_details"
                    className="btn ddfg"
                    onClick={handleNextSubmit}
                  >
                    Next
                  </button>
                </div>
                <br />
              </div>
              <div
                className={`tab-pane ${
                  activeTab === "list_address_details5" ? "active" : "fade"
                }`}
                id="per_details2"
              >
                <div className="panel panel-default">
                  <div className="panel-body" style={{ padding: "0px" }}>
                    <div className="col-md-12" style={{ padding: 0 }}>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="f_name">LIMIT GROUP NAME</label>
                          <input
                            type="text"
                            className={`form-control ${errors.limit_group_name ? 'is-invalid' : ''}`}
                            id="limit_group_name"
                            placeholder="Enter Limit Group Name"
                            name="limit_group_name"
                            value={formData.limit_group_name}
                            onChange={handleChange}
                          />
                          <span id="error_fname" className="text-danger">
                            {errors.limit_group_name}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MINIMUM AMOUNT</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.min_amount_cashout_limit ? 'is-invalid' : ''}`}
                            id="min_amount_cashout_limit"
                            placeholder="Enter Minimum Amount"
                            name="min_amount_cashout_limit"
                            value={payoutFormData.min_amount_cashout_limit}
                            onChange={handlePayoutChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.min_amount_cashout_limit}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MAXIMUM AMOUNT</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.max_amount_cashout_limit ? 'is-invalid' : ''}`}
                            id="max_amount_cashout_limit"
                            placeholder="Enter Maximum Amount"
                            name="max_amount_cashout_limit"
                            value={payoutFormData.max_amount_cashout_limit}
                            onChange={handlePayoutChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.max_amount_cashout_limit}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="panel panel-default">
                  <div className="panel-body" style={{ padding: "0px" }}>
                    <div className="col-md-12" style={{ padding: 0 }}>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        Transaction Limits
                      </h6>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">DAILY</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.daily_cash_out_limit ? 'is-invalid' : ''}`}
                            id="daily_cash_out_limit"
                            placeholder="Enter Daily Limits"
                            name="daily_cash_out_limit"
                            value={payoutFormData.daily_cash_out_limit}
                            onChange={handlePayoutChange}
                          />
                          <span id="error_fname" className="text-danger">
                            {errors.daily_cash_out_limit}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">WEEKLY</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.weekly_cash_out_limit ? 'is-invalid' : ''}`}
                            id="weekly_cash_out_limit"
                            placeholder="Enter Weekly Limits"
                            name="weekly_cash_out_limit"
                            value={payoutFormData.weekly_cash_out_limit}
                            onChange={handlePayoutChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.weekly_cash_out_limit}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MONTHLY</label>
                          <input
                            type="number"
                            data-decimal="2"
                            oninput="enforceNumberValidation(this)"
                            className={`form-control ${errors.monthly_cash_out_limit ? 'is-invalid' : ''}`}
                            id="monthly_cash_out_limit"
                            placeholder="Enter Monthly Limits"
                            name="monthly_cash_out_limit"
                            value={payoutFormData.monthly_cash_out_limit}
                            onChange={handlePayoutChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.monthly_cash_out_limit}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="panel panel-default">
                  <div className="panel-body" style={{ padding: "0px" }}>
                    <div className="col-md-12" style={{ padding: 0 }}>
                      <h6 style={{ fontWeight: "600", fontSize: "14px" }}>
                        Transaction Count
                      </h6>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="f_name">DAILY</label>
                          <input
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,0);"
                            className={`form-control ${errors.daily_cash_out_limit_count ? 'is-invalid' : ''}`}
                            id="daily_cash_out_limit_count"
                            placeholder="Enter Daily Count"
                            name="daily_cash_out_limit_count"
                            value={payoutFormData.daily_cash_out_limit_count}
                            onChange={handlePayoutChange}
                          />
                          <span id="error_fname" className="text-danger">
                            {errors.daily_cash_out_limit_count}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">WEEKLY</label>
                          <input
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,0);"
                            className={`form-control ${errors.weekly_cash_out_limit_count ? 'is-invalid' : ''}`}
                            id="weekly_cash_out_limit_count"
                            placeholder="Enter Weekly Count"
                            name="weekly_cash_out_limit_count"
                            value={payoutFormData.weekly_cash_out_limit_count}
                            onChange={handlePayoutChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.weekly_cash_out_limit_count}
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ padding: "0px", paddingRight: "15px" }}
                      >
                        <div
                          className="form-group frm"
                          style={{ textAlign: "left" }}
                        >
                          <label for="Transaction">MONTHLY</label>
                          <input
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,0);"
                            className={`form-control ${errors.monthly_cash_out_limit_count ? 'is-invalid' : ''}`}
                            id="monthly_cash_out_limit_count"
                            placeholder="Enter Monthly Count"
                            name="monthly_cash_out_limit_count"
                            value={payoutFormData.monthly_cash_out_limit_count}
                            onChange={handlePayoutChange}
                          />
                          <span id="error-message" className="text-danger">
                            {errors.monthly_cash_out_limit_count}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <br />
                <div align="left">
                  <button
                    type="button"
                    name="previous_btn_personal_details4"
                    id="previous_btn_personal_details4"
                    className="btn ddfgg"
                    onClick={() => handleTabClick("list_per_details5")}
                  >
                    Previous
                  </button>
                  <button
                    type="submit"
                    name="btn_asubmit"
                    id="btn_limits_details"
                    className="btn ddfg"
                    style={{ marginLeft: 5 }}
                  >
                    Submit
                  </button>
                </div>
                <br />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default AddAgentLimitView;
